import './App.css';
import { Routes, Route} from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Faq from './pages/Faq';
import Footer from './components/Footer';
import { Box } from '@mui/material';

function App() {
  return (
<>
  <Box display="flex" flexDirection="column" minHeight="100vh">
    {/* Navbar fix */}
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 1100,
        bgcolor: "background.paper",
        boxShadow: 1
      }}
    >
      <Navbar />
    </Box>

    {/* Conținut cu padding ca să nu fie sub navbar */}
    <Box flex="1" sx={{ mt: "64px" }}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/faq" element={<Faq />} />
      </Routes>
    </Box>

    <Footer />
  </Box>
</>


  );
}

export default App;


